import { render } from "./AddMember.vue?vue&type=template&id=31484f91&scoped=true"
import script from "./AddMember.vue?vue&type=script&lang=js"
export * from "./AddMember.vue?vue&type=script&lang=js"

import "./AddMember.vue?vue&type=style&index=0&id=31484f91&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31484f91"]])

export default __exports__